import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

class Placeholder extends Component {
    constructor(props) {
        super(props);
        this.GraphIcon = this.props.graphic;
        this.TitleText = this.props.title;
        this.ParagraphText = this.props.paragraph;
    }

    render(){
        return(
            <Row>
                <Col lg="12" className="Main-Center-Graph">
                    <img src={this.GraphIcon} alt="Graph Icon"></img>
                    <h2>{this.TitleText}</h2>
                    <p>{this.ParagraphText}</p>
                </Col>
            </Row>
        );
    }
}
export default Placeholder;